import { z } from "zod";
import dealSubmissionContract from "../generated/deal-submission-contract";

const NonBlankSchema = z.string().trim().min(1);

z.object({
  slugPrefix: NonBlankSchema,
  intakeStatus: NonBlankSchema,
  activityTypes: z.object({
    submitted: NonBlankSchema,
    reviewSubmitted: NonBlankSchema,
  }),
  categories: z
    .array(z.object({ category: NonBlankSchema, sector: NonBlankSchema }))
    .min(1),
  findings: z
    .array(
      z.object({
        kind: NonBlankSchema,
        outcome: z.enum(["ACCEPTED", "REJECTED"]),
        reasonRequired: z.boolean(),
      }),
    )
    .min(1),
  findingPayload: z.object({
    versionId: z.object({
      type: z.literal("integer"),
      minimum: z.number().int(),
    }),
    reason: z
      .object({
        minLength: z.number().int().positive(),
        maxLength: z.number().int().positive(),
      })
      .refine(({ minLength, maxLength }) => minLength <= maxLength),
  }),
  reviewScenarios: z
    .array(z.object({ scenario: NonBlankSchema, finding: NonBlankSchema }))
    .min(1),
}).parse(dealSubmissionContract);

export const DEAL_SUBMISSION_CONTRACT = dealSubmissionContract;
